/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speechmatics_Target_Language_HungarianInputs */

const en_speechmatics_target_language_hungarian = /** @type {(inputs: Speechmatics_Target_Language_HungarianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hungarian`)
};

const fr_speechmatics_target_language_hungarian = /** @type {(inputs: Speechmatics_Target_Language_HungarianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hongrois`)
};

const de_speechmatics_target_language_hungarian = /** @type {(inputs: Speechmatics_Target_Language_HungarianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ungarisch`)
};

const it_speechmatics_target_language_hungarian = /** @type {(inputs: Speechmatics_Target_Language_HungarianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ungherese`)
};

const ru_speechmatics_target_language_hungarian = /** @type {(inputs: Speechmatics_Target_Language_HungarianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`венгерский`)
};

const es_speechmatics_target_language_hungarian = /** @type {(inputs: Speechmatics_Target_Language_HungarianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`húngaro`)
};

const zh_cn2_speechmatics_target_language_hungarian = /** @type {(inputs: Speechmatics_Target_Language_HungarianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`匈牙利`)
};

const ja_speechmatics_target_language_hungarian = /** @type {(inputs: Speechmatics_Target_Language_HungarianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ハンガリー語`)
};

const hi_speechmatics_target_language_hungarian = /** @type {(inputs: Speechmatics_Target_Language_HungarianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हंगेरी`)
};

const pt_pt2_speechmatics_target_language_hungarian = /** @type {(inputs: Speechmatics_Target_Language_HungarianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`húngaro`)
};

/**
* | output |
* | --- |
* | "Hungarian" |
*
* @param {Speechmatics_Target_Language_HungarianInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speechmatics_target_language_hungarian = /** @type {((inputs?: Speechmatics_Target_Language_HungarianInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speechmatics_Target_Language_HungarianInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_speechmatics_target_language_hungarian(inputs)
	if (locale === "de") return de_speechmatics_target_language_hungarian(inputs)
	if (locale === "it") return it_speechmatics_target_language_hungarian(inputs)
	if (locale === "ru") return ru_speechmatics_target_language_hungarian(inputs)
	if (locale === "es") return es_speechmatics_target_language_hungarian(inputs)
	if (locale === "zh-CN") return zh_cn2_speechmatics_target_language_hungarian(inputs)
	if (locale === "ja") return ja_speechmatics_target_language_hungarian(inputs)
	if (locale === "hi") return hi_speechmatics_target_language_hungarian(inputs)
	if (locale === "pt-PT") return pt_pt2_speechmatics_target_language_hungarian(inputs)
	return en_speechmatics_target_language_hungarian(inputs)
});